<header class="hero">

  <div class="hero__bg">
    <picture>
      <source media="(min-width: 1024px)" srcset="assets/header/bg-desktop.webp">
      <source media="(min-width: 768px)" srcset="assets/header/bg-tablet.webp">
      <img src="assets/header/bg-mobile.webp" alt="Amanecer en Establecimiento La Angélica" class="hero__img">
    </picture>
    <div class="hero__overlay"></div>
  </div>

  <div class="hero__content">
    <h1 class="hero__title">
      <span class="hero__eyebrow">Desconectá.</span>
      Tu refugio de campo <br> en Concordia, Entre Ríos.
    </h1>

    <div class="hero__actions">
      <a (click)="scrollToSection('contacto')" class="btn btn--primary pulse-animation">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path
            d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zm-7 5h5v5h-5z" />
        </svg>
        Reservá y cotizá tu estadía
      </a>

      <div class="hero__grid-links">
        <a routerLink="/hospedaje" class="btn btn--secondary">
          Conocé las Casas
        </a>
        <a href="https://api.whatsapp.com/send?phone=5493454055364&text=Consulta%20desde%20www.establecimientolangelica.com.ar"
          target="_blank" class="btn btn--secondary">
          Promos Vigentes
        </a>
      </div>

      <a routerLink="/quienes-somos" class="hero__link-text">¡Conocenos!</a>
    </div>
  </div>

  <div class="hero__trust-bar">
    <div class="trust-container">
      <div class="trust-avatar">
        <img src="assets/avatar-duenos.jpg" alt="Dueños La Angélica">
      </div>
      <div class="trust-info">
        <p class="trust-text">¿Dudas? Chatea con los dueños</p>
        <a href="https://api.whatsapp.com/send?phone=5493454055364&text=Consulta%20desde%20www.establecimientolangelica.com.ar" class="trust-link" target="_blank">
          Respondemos ahora <span class="arrow">→</span>
        </a>
      </div>
      <div class="trust-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#25D366">
          <path
            d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2z" />
        </svg>
      </div>
    </div>
  </div>
</header>


<!-- <div class="header-content" [ngStyle]="{'background-image': 'url(' + path + ')'}">

  <div class="mask-header">
    <div class="content">
      <div class="saludo">
        <h1>
          Mas que un lugar,<br>
          un legado...
        </h1>
      </div>

      <div class="content-widgets">
        <div class="tiempo bg" *ngIf="weather">
          <div class="clima">{{weather.main.temp}}<span>ºC</span></div>
          <div class="city">Concordia, E.R.</div>
        </div>
        <div class="reloj bg">
          <div class="hora">
            <div class="numbers">
              {{ ahora | date: 'hh:mm'}}
            </div>
            <span>{{ ahora | date: 'a'}}</span>
          </div>
          <div class="fecha">
            <span>{{fecha.diaSemana}}</span>
            <span>{{fecha.dia}} de {{fecha.mes}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
 -->
